/**
 * GET `admin/clinic-applications/:id` — карточка одной заявки.
 *
 * Поля те же, что в строке списка (плюс пара служебных id, которые
 * интерфейсу не нужны), поэтому разбираем тем же маппером. Ручка нужна
 * не ради новых полей, а ради свежести: очередь заявок разбирают
 * несколько человек, и строка в открытом списке успевает устареть —
 * открыв карточку, человек должен видеть текущий статус, а не тот, что
 * был на момент загрузки страницы.
 */

import {http} from '@services/utils';

import {toApplicationItem} from '../toApplicationItem';
import type {ApplicationItem} from '../types';

export const getApplication = async (id: string): Promise<ApplicationItem | null> => {
  const raw = await http<unknown>(`admin/clinic-applications/${encodeURIComponent(id)}`, {
    skipCaseConversion: true,
  });
  return toApplicationItem(raw);
};
